import { RepositorioTax } from "@/components/operacoes/RepositorioTax";

export function RepositorioPage() {
  return <RepositorioTax />;
}
